import React from 'react'
import PropTypes from 'prop-types'
import {
  ButtonWrapper,
  CircleIcon,
  StyledButton,
  StyledCheckIcon,
  Text,
} from './component.styles'

const NavigatorButton = ({
  children,
  isActive,
  isCompleted,
  label,
  onClick,
}) => {
  return (
    <ButtonWrapper>
      <StyledButton
        isActive={isActive}
        isCompleted={isCompleted}
        label={label}
        onClick={onClick}
      >
        <CircleIcon isActive={isActive} isCompleted={isCompleted}>
          {isCompleted && <StyledCheckIcon />}
        </CircleIcon>
        <Text isActive={isActive}>{children}</Text>
      </StyledButton>
    </ButtonWrapper>
  )
}

NavigatorButton.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  isCompleted: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default NavigatorButton
